import { FC } from 'react';
import { Col, Row, Typography } from 'antd';
import V2Table from '@/common/components/Data/V2Table';
import { useMethods } from '@lhb/hook';
import darkTableStyle from '../index.module.less';
import styles from './index.module.less';
import cs from 'classnames';
import Block from '../Block';
import Card from '../Card';

/**
 * 分析完成结果-周边商圈
 * @description
 * @demo
 */
const Surround: FC<{}> = () => {

  /* methods */
  const methods = useMethods({
    async loadData() {
      const data: any[] = [
        {
          distanceName: '500米商圈内',
          workPopulationOwnShop: '6314',
          workPopulationAvg: '5902',
          livePopulationOwnShop: '1.6万',
          livePopulationAvg: '1.5万',
          permanentPopulationOwnShop: '1.6万',
          permanentPopulationAvg: '1.7万'
        },
        {
          distanceName: '1.5km商圈内',
          workPopulationOwnShop: '6.8万',
          workPopulationAvg: '6.7万',
          livePopulationOwnShop: '15.2万',
          livePopulationAvg: '14.9万',
          permanentPopulationOwnShop: '15.7万',
          permanentPopulationAvg: '15.6万'
        },
        {
          distanceName: '3km商圈内',
          workPopulationOwnShop: '20.7万',
          workPopulationAvg: '21.1万',
          livePopulationOwnShop: '39.4万',
          livePopulationAvg: '39.6万',
          permanentPopulationOwnShop: '39.9万',
          permanentPopulationAvg: '39.8万'
        },
      ];

      return {
        dataSource: data,
        count: data.length,
      };
    },
    /**
     * @description 渲染统计数据列，需要区分高亮与否
     * @param val 字段值
     * @param record 本条记录
     * @param highlightCol 是否高亮列
     * @return
     */
    renderCount(val, highlightCol) {
      return (
        <Typography.Text className={cs(styles.countValue, highlightCol && styles.highlight)}>{val}</Typography.Text>
      );
    }
  });

  /**
   * @description 普通的数字列
   */
  const countColumn = {
    width: 88, align: 'right', render: (val) => methods.renderCount(val, false)
  };
  /**
   * @description 高亮的数字列
   */
  const highlightCountColumn = {
    width: 88, align: 'right', render: (val) => methods.renderCount(val, true)
  };

  const defaultColumns: any[] = [
    {
      title: '商圈范围', key: 'distance', width: 110,
      children: [
        { key: 'distanceName', title: '-', width: 110, align: 'left',
          render: (val) => <Typography.Text style={{ width: '55px' }}>{val}</Typography.Text>
        },
      ],
    },
    {
      title: '办公人口', key: 'workPopulation', width: 176,
      children: [
        { ...highlightCountColumn, key: 'workPopulationOwnShop', title: '本门店覆盖' },
        { ...countColumn, key: 'workPopulationAvg', title: '平均覆盖' },
      ],
    },
    {
      title: '居住人口', key: 'livePopulation', width: 176,
      children: [
        { ...highlightCountColumn, key: 'livePopulationOwnShop', title: '本门店覆盖' },
        { ...countColumn, key: 'livePopulationAvg', title: '平均覆盖' },
      ],
    },
    {
      title: '办公人口', key: 'permanentPopulation', width: 176,
      children: [
        { ...highlightCountColumn, key: 'permanentPopulationOwnShop', title: '本门店覆盖' },
        { ...countColumn, key: 'permanentPopulationAvg', title: '平均覆盖' },
      ],
    },
  ];

  return (
    <Block className={styles.surround}>
      <span className={styles.title}>周边商圈分析</span>
      <div className={cs(styles.charts, 'mt-10')}>
        <Row gutter={10}>
          <Col span={12}>
            <Card title='点位周边客流热力' className={styles.heatmap}>
              <div className={styles.imageWrapper}>
                <img src={`${process.env.STATIC_RES_DOMAIN}/project-custom/locationpc/chancepoint/ai-predict-entry-rate/report-result/suround_heatmap.png`} />
              </div>
            </Card>
          </Col>
          <Col span={12}>
            <Card title='周边商圈业态分布' className={styles.industry}>
              <div className={styles.imageWrapper}>
                <img src={`${process.env.STATIC_RES_DOMAIN}/project-custom/locationpc/chancepoint/ai-predict-entry-rate/report-result/suround_industry.png`} />
              </div>
            </Card>
          </Col>
        </Row>
      </div>

      <div className={cs(styles.popuTable, 'mt-16')}>
        <div className={cs(styles.subtitle)}>门店覆盖人口分布</div>
        <V2Table
          rowKey='key'
          filter={{}}
          onFetch={methods.loadData}
          defaultColumns={defaultColumns}
          hideColumnPlaceholder
          pagination={false}
          floorWidth={50}
          className={cs(styles.table, darkTableStyle.darkTable, 'mt-8')}
        />
      </div>
    </Block>
  );
};

export default Surround;
